var _rect, _rect2, _rect3, _rect4, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeclinedIconIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-rejected-1733375",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.097,
    height: 15.24,
    viewBox: "0 0 15.097 15.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3873",
    "data-name": "Rectangle 3873",
    width: 7.985,
    height: 0.556,
    transform: "translate(1.603 2.095)",
    fill: "#d55e47"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3874",
    "data-name": "Rectangle 3874",
    width: 7.985,
    height: 0.556,
    transform: "translate(1.603 3.619)",
    fill: "#d55e47"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3875",
    "data-name": "Rectangle 3875",
    width: 3.985,
    height: 0.556,
    transform: "translate(1.603 5.175)",
    fill: "#d55e47"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3876",
    "data-name": "Rectangle 3876",
    width: 2.889,
    height: 0.556,
    transform: "translate(1.603 6.715)",
    fill: "#d55e47"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9635",
    "data-name": "Path 9635",
    d: "M13.676,7.159V2H2.5V17.24l9.985-.016A5.1,5.1,0,0,0,13.676,7.159ZM14.93,8.683l-5.7,6.144a4.185,4.185,0,0,1-.984-2.715A4.2,4.2,0,0,1,14.93,8.683Zm-11.874,8V2.556H13.12V7.064a4.275,4.275,0,0,0-.635-.048,5.112,5.112,0,0,0-2.318,9.668Zm9.43-.333a4.2,4.2,0,0,1-2.619-.921L15.6,9.239a4.235,4.235,0,0,1-3.111,7.112Z",
    transform: "translate(-2.5 -2)",
    fill: "#d55e47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclinedIconIcon);
export default __webpack_public_path__ + "static/media/declined-icon-icon.81b84218a9c994cdeed5814a61a89eb4.svg";
export { ForwardRef as ReactComponent };